<template>
<v-container fluid class="flex-container-overflow">
  <v-row justify="center" align="center" style="height: 90vh">
    <v-col cols="12" sm="6">
      <div>
        <v-card-title class="title text-center" style="word-break: break-word;">
          <span style="margin: 0 auto;">
            {{ $t('Activation.successMessage') }}
          </span>
        </v-card-title>
        <v-card-text>
          <p class="text-center">
            <router-link to="/login"
                         style="color: #3aa8cc; text-decoration: none;"
                         class="text-uppercase title font-weight-bold"
            >{{ $t('Activation.toLogin') }}</router-link>
          </p>
        </v-card-text>
      </div>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import axiosInstance from '../plugins/axios';

export default {
  name: "Activation",
  async mounted() {
    try {
      console.log(this.$route.query);
      if (this.$route.query) {
        await axiosInstance.post('/auth/users/activation/', this.$route.query);
        setTimeout(() => {
          this.$router.push('/login');
        }, 3000);
      }
    } catch (err) {
      console.log(err);
      if (err.response.data.detail === 'Stale token for given user.') {
        return;
      }
      this.$snackbar({
        timeout: 3000,
        content: 'Error with user activation',
        color: 'error',
      });
    }
  }
}
</script>

<style scoped>

</style>
